module.exports = __webpack_public_path__ + "img/bottom.bc8867b4.png";